export enum Routes {
  Monitoring = "/monitoring",
  MonitoringOrders = "/monitoring/orders",
  MonitoringRemains = "/monitoring/remains-rc",
  MonitoringHistoryOfCashBox = "/monitoring/history-of-cash-box",
  MonitoringLoadOrders = "/monitoring/load-orders",
  Products = "/products",
  ProductsAcceptance = "/products/acceptance",
  ProductsTransfer = "/products/transfer",
  ProductsMarking = "/products/marking",
  ProductsTraffic = "/products/traffic",
  ProductsEquipmentInterZone = "/products/equipment/create-box-interzone",
  ProductsEquipmentInterModal = "/products/equipment/create-box-intermodal",
  ProductsEquipment = "/products/equipment",
  ProductsStorage = "/products/storage",
  ProductsZones = "/products/zones",
  ProductsMovement = "/products/movement",
  ProductsInventory = "/products/inventory",
  ProductsProductCards = "/products/product-cards",
  Shipment = "/shipment",
  ShipmentCashBox = "/shipment/cash-box",
  ShipmentIssueClient = "/shipment/issues-client",
  ShipmentReturns = "/shipment/returns",
  ShipmentShipment = "/shipment/shipments",
  Staff = "/staff",
  StaffShifts = "/staff/shifts",
  StaffPermissions = "/staff/permissions",
  Settings = "/settings",
  SettingsAddressStorage = "/settings/address-storage",
  SettingsSettingsRc = "/settings/setting-rc",
  SettingsEmployees = "/settings/employees",
  SettingsWorkers = "/settings/workers",
  QrCode = "/settings/qr-code",
  LoginPage = "/auth/login",
  ForgetPassword = "/auth/forget-password",
}
